import { render, staticRenderFns } from "./ToDoListCompleted.vue?vue&type=template&id=9ba279c2&"
import script from "./ToDoListCompleted.vue?vue&type=script&lang=js&"
export * from "./ToDoListCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ToDoListCompleted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports